
import { transformAsync } from '@babel/core';
import plugin0 from
'@babel/plugin-syntax-dynamic-import';
import plugin1 from
'@babel/plugin-proposal-class-properties';
import plugin2 from
'@babel/plugin-proposal-private-methods';
import plugin3 from
'@babel/plugin-proposal-numeric-separator';
import plugin4 from
'@babel/plugin-proposal-logical-assignment-operators';
import plugin5 from
'@babel/plugin-proposal-nullish-coalescing-operator';
import plugin6 from
'@babel/plugin-proposal-optional-chaining';
import plugin7 from
'@babel/plugin-proposal-json-strings';
import plugin8 from
'@babel/plugin-proposal-optional-catch-binding';
import plugin9 from
'@babel/plugin-transform-parameters';
import plugin10 from
'@babel/plugin-proposal-async-generator-functions';
import plugin11 from
'@babel/plugin-proposal-object-rest-spread';
import plugin12 from
'@babel/plugin-transform-dotall-regex';
import plugin13 from
'@babel/plugin-proposal-unicode-property-regex';
import plugin14 from
'@babel/plugin-transform-named-capturing-groups-regex';
import plugin15 from
'@babel/plugin-transform-async-to-generator';
import plugin16 from
'@babel/plugin-transform-exponentiation-operator';
import plugin17 from
'@babel/plugin-transform-template-literals';
import plugin18 from
'@babel/plugin-transform-literals';
import plugin19 from
'@babel/plugin-transform-function-name';
import plugin20 from
'@babel/plugin-transform-arrow-functions';
import plugin21 from
'@babel/plugin-transform-block-scoped-functions';
import plugin22 from
'@babel/plugin-transform-classes';
import plugin23 from
'@babel/plugin-transform-object-super';
import plugin24 from
'@babel/plugin-transform-shorthand-properties';
import plugin25 from
'@babel/plugin-transform-duplicate-keys';
import plugin26 from
'@babel/plugin-transform-computed-properties';
import plugin27 from
'@babel/plugin-transform-for-of';
import plugin28 from
'@babel/plugin-transform-sticky-regex';
import plugin29 from
'@babel/plugin-transform-unicode-escapes';
import plugin30 from
'@babel/plugin-transform-unicode-regex';
import plugin31 from
'@babel/plugin-transform-spread';
import plugin32 from
'@babel/plugin-transform-destructuring';
import plugin33 from
'@babel/plugin-transform-block-scoping';
import plugin34 from
'@babel/plugin-transform-typeof-symbol';
import plugin35 from
'@babel/plugin-transform-new-target';
import plugin36 from
'@babel/plugin-proposal-export-namespace-from';
import plugin37 from
'@babel/plugin-transform-modules-commonjs';
import plugin38 from
'@babel/plugin-proposal-dynamic-import';
import plugin39 from
'@babel/plugin-transform-react-jsx';
import plugin40 from
'@babel/plugin-transform-react-display-name';
import plugin41 from
'@babel/plugin-transform-react-pure-annotations';

/**
 * Transforms source code using settings from brower.json
 *
 * Returns a promise containing the source.
 *
 * @parameter {string} source
 * @returns Promise<string>
 */
export async function babelWithEnv(source, inputSourceMap) {
  try {
    const result = await transformAsync(source, {
      sourceType: 'script',
      plugins: [plugin0,
plugin1,
plugin2,
plugin3,
plugin4,
plugin5,
plugin6,
plugin7,
plugin8,
plugin9,
plugin10,
plugin11,
plugin12,
plugin13,
plugin14,
plugin15,
plugin16,
plugin17,
plugin18,
plugin19,
plugin20,
plugin21,
plugin22,
plugin23,
plugin24,
plugin25,
plugin26,
plugin27,
plugin28,
plugin29,
plugin30,
plugin31,
plugin32,
plugin33,
plugin34,
plugin35,
plugin36,
plugin37,
plugin38,
plugin39,
plugin40,
plugin41],
      sourceMaps: 'both',
      sourceFileName: 'popcodePreview.js',
      inputSourceMap,
    });

    return {
      code: result.code,
      sourceMap: result.map
    };
  } catch (e) {
    throw new Error(e);
  }
}
    